import { UUID } from '@belimo-retrofit-portal/logic';
import * as D from 'io-ts/Decoder';
import { ASSET } from 'src/modules/common/codecs/Asset';
import { PROJECT_ROLE } from 'src/modules/common/codecs/ProjectRole';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';

export const SHARED_USER: D.Decoder<unknown, SharedUser> = D.struct({
  id: UUID,
  role: PROJECT_ROLE,
  email: D.string,
  firstName: D.string,
  lastName: D.string,
  jobTitle: D.string,
  avatar: D.nullable(ASSET),
  avatarColor: D.string,
});
